import { render } from "./PanelParadasRuta.vue?vue&type=template&id=a373510a&scoped=true"
import script from "./PanelParadasRuta.vue?vue&type=script&lang=js"
export * from "./PanelParadasRuta.vue?vue&type=script&lang=js"

import "./PanelParadasRuta.vue?vue&type=style&index=0&id=a373510a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a373510a"]])

export default __exports__